import {
	Component,
	OnInit,
	ViewEncapsulation,
	HostBinding,
	Input,
	Output,
	EventEmitter,
	ChangeDetectionStrategy
} from "@angular/core";
import { IdService } from "../../shared/services/id.service";
import { Locale } from "../datatable.models";

@Component({
	selector: "rbc-datatable-global-searcher",
	templateUrl: "./datatable-global-searcher.component.html",
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DatatableGlobalSearcherComponent {
	@Input() locale = Locale;
	@Input() id: string;

	@Output() onGlobalSearchFocusOut = new EventEmitter();
	@Output() onGlobalSearchTermUpdate = new EventEmitter();

	@Input() globalSearchTerm = "";

	constructor(private idService: IdService) {
		this.id = this.idService.generate();
	}

	$_GlobalSearch_focusOut(obj) {
		this.onGlobalSearchFocusOut.emit({
			value: obj ? obj : ""
		});
	}

	// Called when global search term changes
	$_GlobalSearch_inputUpdate(obj) {
		this.onGlobalSearchTermUpdate.emit({
			value: obj ? obj : ""
		});

	}
	$_GlobalSearch_reset() {
		// this.globalSearchTerm = "";
		this.onGlobalSearchTermUpdate.emit({
			value: ""
		});
	}
}
